// Core
import useSWR from "swr";

// Definitions
import type { ProvidersFilterParamsType, ProvidersListType, ProviderType } from "../types";
import type { HttpResponseAxiosDataType, HttpResponseAxiosErrorType } from "@/types/http";
import type { PaginationType } from "@/types/basic";

// Utils
import { providersApi } from "../service";
import { providersKeys } from "../apiKeys";

type UseProvidersFetchType = {
  loadingProvidersFetch: boolean;
  providers: ProviderType[];
  pagination: PaginationType | null;
};

type UseProviderFetchType = {
  loadingProviderFetch: boolean;
  provider: ProviderType | null;
};

const fetcher = (params?: ProvidersFilterParamsType) => () =>
  providersApi.fetchProviders({ params });

export const fetcherOne = (slug: string) => () => providersApi.fetchOneProvider({ slug });

export const useOneProviderFetch = (slug: string): UseProviderFetchType => {
  const { data, isLoading, isValidating } = useSWR<
    HttpResponseAxiosDataType<ProviderType>,
    HttpResponseAxiosErrorType
  >([providersKeys.providers, slug], fetcherOne(slug));
  return {
    loadingProviderFetch: isLoading || isValidating,
    provider: data?.data || null,
  };
};

export const useProvidersFetch = (
  props?: ProvidersFilterParamsType | null,
): UseProvidersFetchType => {
  const { data, isLoading, isValidating } = useSWR<
    HttpResponseAxiosDataType<ProvidersListType>,
    HttpResponseAxiosErrorType
  >([providersKeys.providers, props], fetcher(props ? props : void 0));
  return {
    loadingProvidersFetch: isLoading || isValidating,
    providers: data?.data?.items || [],
    pagination: data?.data?.meta || null,
  };
};
